/*
 * Copyright (c) 2024. Spin in het Web B.V. Apeldoorn NL.
 * Deze software is géén open source. Het auteursrecht van deze software
 * ligt bij Spin in het Web B.V. en/of Jellybean B.V. en/of de auteur.
 * Gebruik van deze software is onderhevig aan een licentieovereenkomst.
 * www.spininhetweb.nl
 */

/*
 * public-api-zonder-editor.ts
 * 26-09-2026 - Jelmer Jellema - Spin in het Web B.V.
 * Gegenereerd met Claude Code (AI), 26-09-2026
 *
 * De public API zonder de editor-onderdelen, en dus zonder quill en ngx-quill. Dit is de entry van
 * ng-package.zonder-editor.json, voor apps die de editor niet gebruiken (zie angular-library-readme.md).
 * public-api.ts bouwt hierop voort: een nieuw onderdeel dat geen quill nodig heeft, hoort hier.
 */

export * from './lib/types';
export * from './lib/localconfig';
export * from './lib/sihwlog';
export * from './lib/keyedtimeout';
export * from './lib/spinjs';
export * from './lib/sihwconfirm';
export * from './lib/sihwcache';
export * from './lib/sihwdatumveld';
export * from './lib/sihwdatepicker';
